const ACCESS_TOKEN_KEY = 'mozio-auth-token'
const REFRESH_TOKEN_KEY = 'mozio-refresh-token'

export const setAccessToken = (token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

export const setRefreshToken = (token) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY) ?? undefined
}

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined
}

export const removeTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}
